import _ from 'lodash'
import { PhoneVerification } from '@adc/ui-core'
const { isValidPhone, PHONE_ERROR } = PhoneVerification.utils

export const isRequired = (value, errorMsg = 'Required') =>
  value || typeof value === 'number' ? undefined : errorMsg

export const validPassword = (
  value,
  errorMsg = 'Password should be between 6 to 20 characters'
) => (value && value.length >= 6 && value.length <= 20 ? undefined : errorMsg)

export const validLocationMin = value =>
  value && _.isArray(value) && value.length > 0
    ? undefined
    : 'Enter up to 5 locations of interest'

export const validLocationMax = value =>
  value && _.isArray(value) && value.length <= 5
    ? undefined
    : '5 location is limit'

export default () => ({
  auth_login: values => {
    const errors = {}
    errors.email = isRequired(values.email, 'Enter a valid email address')
    errors.password = isRequired(values.password, 'Enter a valid password')
    return errors
  },

  auth_signup: (values, props) => {
    const errors = {}
    errors.firstName = isRequired(values.firstName, 'Enter a first name')
    errors.lastName = isRequired(values.lastName, 'Enter a last name')
    errors.email = isRequired(values.email, 'Enter a valid email')
    errors.password = validPassword(values.password)
    if (props.shouldRequirePhone) {
      errors.phone = isValidPhone(values.phone) ? undefined : PHONE_ERROR
    }
    return errors
  },
})
